import { mapGetters, mapState } from 'vuex';
import appHeader from '@/components/app/app-header/app-header.vue';
import appHeaderNew from '@/components/app/app-header/app-header-new.vue';
import appMainNav from '@/components/app/app-main-nav/app-main-nav.vue';
import appFooter from '@/components/app/app-footer/app-footer.vue';
import notificationItems from '@/components/notification-items/notification-items.vue';
import maintenanceNotification from '@/components/maintenance-notification/maintenance-notification.vue';
import searchBar from '@/components/app/app-header/search-bar/search-bar.vue';
import sideNotification from '@/components/generics/side-notification/side-notification.vue';
import constants from '@/constants';

const SIMPLE_LAYOUT_ROUTES = [
  'disqus-auth',
  'disqus-logout',
];


export default {
  components: {
    appHeader,
    appMainNav,
    appFooter,
    maintenanceNotification,
    notificationItems,
    searchBar,
    sideNotification,
  },
  computed: {
    ...mapGetters('browse', ['areUserBrowseHeadersEmpty']),
    ...mapGetters('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutDesktop']),
    ...mapState('app', ['hasServerErrorOccurred', 'liveUpdatesDisabled', 'newHeaderEnabled']),
    ...mapState('popup', ['currentPopup', 'currentSmallPopup']),
    ...mapState('notifications', [
      'sideNotificationLevel',
      'sideNotificationText',
      'sideNotificationOnCloseCallback',
      'showNotificationsWidget',
    ]),
    ...mapGetters('app', ['isLayoutMobile', 'isShutdownModeOn']),
    ...mapGetters('user', ['isUserRestricted']),
    headerComponent() {
      return this.newHeaderEnabled ? appHeaderNew : appHeader;
    },
    isSimpleLayout() {
      return SIMPLE_LAYOUT_ROUTES.includes(this.$route.name);
    },
    appModifiers() {
      return {
        'app-layout-old': true,
        'app-layout-old--with-overflow': (
          (this.currentPopup !== null || this.currentSmallPopup !== null) &&
          constants.POPUP_OVERFLOW_MODE
        ),
      };
    },
    headerModifiers() {
      return {
        'app-layout-old__header': true,
        'app-layout-old__header--shutdown': (this.isShutdownModeOn || this.areUserBrowseHeadersEmpty),
        'app-layout-old__header--secondary': !this.isShutdownModeOn && !this.areUserBrowseHeadersEmpty,
        'app-layout-old__header--error': (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout-old__header--notifications-widget-open': this.showNotificationsWidget,
      };
    },
    contentModifiers() {
      return {
        'app-layout-old__content': true,
        'app-layout-old__content--secondary': !this.isSimpleLayout && !this.isShutdownModeOn && !this.areUserBrowseHeadersEmpty,
        'app-layout-old__content--shutdown': (this.isShutdownModeOn || this.areUserBrowseHeadersEmpty),
        'app-layout-old__content--simple': this.isSimpleLayout,
        'app-layout-old__content--error': (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout-old__content--with-overflow': (
          this.$route.meta.appContentOverflowed ||
          (this.$route.meta.appContentOverflowedDesktop && this.isLayoutDesktop)
        ),
      };
    },
    sideNotificationShouldDisplay() {
      return this.sideNotificationLevel && this.sideNotificationText;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-layout/app-layout.js